import {
  PUSH_NOTIFICATIONS_GET_STATUS,
  PUSH_NOTIFICATIONS_UPDATE,
  FETCH_PUSH_NOTIFICATIONS,
  CREATE_PUSH_NOTIFICATION,
  DELETE_PUSH_NOTIFICATION
} from "../../store/constants/pushNotifications";

export function getPushNotificationsStatus() {
  return {
    type: PUSH_NOTIFICATIONS_GET_STATUS
  };
}

export function updatePushNotifications(enabled = false) {
  return {
    type: PUSH_NOTIFICATIONS_UPDATE,
    enabled
  };
}

export function fetchPushNotifications() {
  return {
    type: FETCH_PUSH_NOTIFICATIONS
  };
}

export function createPushNotification(payload = {}) {
  return {
    type: CREATE_PUSH_NOTIFICATION,
    payload
  };
}

export function deletePushNotification(id = null) {
  return {
    type: DELETE_PUSH_NOTIFICATION,
    id
  };
}
